import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";

export const getAllB2BInquiries = createAsyncThunk(
  "InquirySources/FindAllB2BInquiry",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/InquirySources/FindAllB2BInquiry`,
        formdata,
      );

      const result = response.data?.Data;
      return result;
      //   return result?.map((booking: any) => {
      //     return {
      //       ...booking,
      //       Name: `${booking?.FirstName} ${booking?.LastName}`,
      //       Duration: `${+booking?.NoOfNights || 0}N / ${+booking?.NoOfDays || 0}D`,
      //     };
      //   });
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Inquiries:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
